
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './NewFollowUp.module.scss';
import { decryptedAdminID, getInitials, MyModal, timeRemove } from '../../utility';
import ModalContainer from '../../components/modal_popup';
import ActionMenu from "../../components/Common/ActionMenu";
import NewFilterFollowUp from './NewFilterFollowUp';
import { useDispatch, useSelector } from 'react-redux';
import { commonPopupActions } from "../../redux-store/store";
import { getcandidateDetails, getCandidateLead, updateFollowUp } from '../../apiServices';
import { getAdminIds, getReasons } from '../../services/candidateServices';
import {
  fetchAllColumns,
  fetchFollowUps,
  updateColumnFilter,
  resetColumnFilter,
  updateGlobalFilter,
  resetGlobalFilter,
  setColumnPage,
  setShowFilterModal,
  clearError,
  setAdminIds
} from '../../redux-store/slices/followUpSlice';
import UpdateFollowUp from './UpdateFollowUp';
import SuccessTick from '../../components/success_tick';
import { AiOutlineClose } from 'react-icons/ai';
import { MdTune } from 'react-icons/md';
import { TfiReload } from 'react-icons/tfi';

// ActionMenu component
// const ActionMenu = ({ task, onClose, onComplete, onEdit, onFollowUp }) => {
//   const handleAction = (action) => {
//     switch (action) {
//       case 'complete':
//         onComplete(task);
//         break;
//       case 'edit':
//         onEdit(task);
//         break;
//       case 'followup':
//         onFollowUp(task);
//         break;
//       default:
//         break;
//     }
//     onClose();
//   };
//  const hideFollowUp = task.title === 'Joining Follow Up' || task.title === 'Interview Follow Up';
//   return (
//     <div className={styles.actionMenu}>
//       <button onClick={() => handleAction('complete')} className={styles.actionMenuItem}>
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
//           <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//         </svg>
//         Complete
//       </button>
//       <button onClick={() => handleAction('edit')} className={styles.actionMenuItem}>
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
//           <path d="M17 3L21 7L7 21H3V17L17 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//         </svg>
//         Edit
//       </button>
//           {!hideFollowUp && (
//       <button onClick={() => handleAction('followup')} className={styles.actionMenuItem}>
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
//           <path d="M19 10L12 17L5 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//           <path d="M12 3L12 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//           <path d="M19 21L5 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//         </svg>
//         Follow-up
//       </button>
//         )}
//     </div>
//   );
// };

const NewFollowUp = ({onSelectCandidate}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeMenuTask, setActiveMenuTask] = useState(null);
  const [showActionModal, setShowActionModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedOutcome, setSelectedOutcome] = useState('');
  const [notes, setNotes] = useState('');
  const [rescheduleDate, setRescheduleDate] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showReasonDropdown, setShowReasonDropdown] = useState(false);
  const [reasonOptions, setReasonOptions] = useState([]);
  const [selectedReason, setSelectedReason] = useState('');
  const [loadingReasons, setLoadingReasons] = useState(false);
  const [errors, setErrors] = useState({
    outcome: '',
    reason: '',
    rescheduleDate: ''
  });

  const [showFollowUpModal, setShowFollowUpModal] = useState(false);
  const [followUpDateTime, setFollowUpDateTime] = useState('');
  const [followUpNotes, setFollowUpNotes] = useState('');
  const [followUpErrors, setFollowUpErrors] = useState({ followUpDateTime: '' });
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [completeSuccess, setCompleteSuccess] = useState(false);
  const [followupSuccess, setFollowupSuccess] = useState(false);
  const [adminList, setAdminList] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);

  const adminID = Number(decryptedAdminID());

  // Get admin details from Redux
  const adminDetails = useSelector((state) => state.adminDetails);
  const isSuperAdmin = adminDetails?.roleID == 1;
const isTeamLeader = localStorage.getItem("teamLeader") == "true";
  // Get data from Redux with fallback
  const followUpState = useSelector((state) => state.followUp) || {
    columns: { todo: { items: [], total: 0 }, pending: { items: [], total: 0 }, completed: { items: [], total: 0 } },
    columnFilters: { todo: {}, pending: {}, completed: {} },
    globalFilter: { dateRange: { start: '', end: '' }, autoComplete: '', priority: null, orderByPriority: false, admin_ids: [], title: null },
    loadingStates: { todo: false, pending: false, completed: false },
    error: null,
    showFilterModal: null
  };

  const {
    columns = { todo: { items: [], total: 0 }, pending: { items: [], total: 0 }, completed: { items: [], total: 0 } },
    columnFilters = { todo: {}, pending: {}, completed: {} },
    globalFilter = { dateRange: { start: '', end: '' }, autoComplete: '', priority: null, orderByPriority: false, admin_ids: [], title: null },
    loadingStates = { todo: false, pending: false, completed: false },
    error = null,
    showFilterModal = null
  } = followUpState;


const fetchAndSetAdmins = async () => {
  try {
    // Get admin list from localStorage
    const storedAdminList = JSON.parse(localStorage.getItem("AdminList") || "[]");
    console.log("AdminList from localStorage:", storedAdminList);
    
    // Format with "Self" for current admin
    const formatted = storedAdminList.map((item) => ({
      id: item.id,
      name: item.id === adminID ? "Self" : item.name,
    }));

    setAdminList(formatted);
    const allIds = formatted.map(a => a.id);
    
    let defaultAdminIds = [];
    if (isSuperAdmin) {
      defaultAdminIds = allIds;
    } else {
      defaultAdminIds = [adminID];
    }

    if (defaultAdminIds.length === 0) {
      defaultAdminIds = [adminID];
    }

    await dispatch(setAdminIds(allIds));
    
    // Set default filters with _adminFilterApplied: false
    dispatch(updateGlobalFilter({ 
      admin_ids: defaultAdminIds, 
      _adminFilterApplied: false 
    }));
    dispatch(updateColumnFilter({ 
      columnKey: 'todo', 
      filterData: { admin_ids: defaultAdminIds, _adminFilterApplied: false } 
    }));
    dispatch(updateColumnFilter({ 
      columnKey: 'pending', 
      filterData: { admin_ids: defaultAdminIds, _adminFilterApplied: false } 
    }));
    dispatch(updateColumnFilter({ 
      columnKey: 'completed', 
      filterData: { admin_ids: defaultAdminIds, _adminFilterApplied: false } 
    }));

    setIsInitialized(true);
    dispatch(fetchAllColumns());

  } catch (err) {
    console.error("❌ Admin Fetch Error:", err);
    await dispatch(setAdminIds([adminID]));
    setIsInitialized(true);
    dispatch(fetchAllColumns());
  }
};


  // Initialize on mount - ONLY fetch admins, let fetchAndSetAdmins handle data fetch
// In NewFollowUp.js - Modified useEffect
useEffect(() => {
  // Only initialize if adminDetails is loaded
  if (adminDetails && Object.keys(adminDetails).length > 0) {
    fetchAndSetAdmins();
  }
  // You might need to add a dependency on adminDetails
}, [adminDetails]); // Add adminDetails as dependency

// In NewFollowUp.js, add this log
console.log('Admin Details after refresh:', {
  adminDetails,
  isSuperAdmin: adminDetails?.roleID == 1,
  adminID
});

  // Rest of your component remains the same...
  const getOutcomeOptions = (taskTitle) => {
    const baseOptions = [
      { value: 'NO_RESPONSE', label: 'No Response' },
      // { value: 'CALL_NOT_ATTENDED', label: 'Call Not Attended' },
      { value: 'COMPLETED', label: 'Completed' },
    ];

    if (taskTitle === 'Joining Follow Up') {
      return [
        ...baseOptions.slice(0, 2),
        { value: 'RESCHEDULE', label: 'Reschedule' },
        { value: 'OFFER_REJECTED', label: 'Offer Rejected' },
        // { value: 'INTERESTED', label: 'Interested' },
        ...baseOptions.slice(2)
      ];
    }

    if (taskTitle === 'Interview Follow Up') {
      return [
        ...baseOptions.slice(0, 2),
        { value: 'RESCHEDULE', label: 'Reschedule' },
        { value: 'NOT_INTERESTED', label: 'Not Interested' },
        // { value: 'INTERESTED', label: 'Interested' },
        ...baseOptions.slice(2)
      ];
    }

    return baseOptions;
  };

const hasRealFilters = (filter) => {
  if (!filter) return false;

  // Check date range - only if BOTH start and end have values
  const hasDateRange = filter.dateRange?.start && filter.dateRange?.end;
  
  // Check priority - only if not null/empty
  const hasPriority = filter.priority && filter.priority !== '' && filter.priority !== null;
  
  // Check title - only if not null/empty
  const hasTitle = filter.title && filter.title !== '' && filter.title !== null;
  
  // Check order by priority - only if explicitly true
  const hasOrderByPriority = filter.orderByPriority === true;

  // ✅ Admin filter - ONLY count if _adminFilterApplied is true AND it's a change from default
  // For Super Admin: default is empty array (ALL), so empty array should NOT trigger red dot
  // For Team Leader/Regular Admin: default is [self], so [self] should NOT trigger red dot
  let hasAdminFilter = false;
  
  if (filter._adminFilterApplied === true) {
    // Get the default admin selection based on role
    const isSuperAdmin = adminDetails?.roleID == 1;
    const isTeamLeader = localStorage.getItem("teamLeader") == "true";
    
    // Default admin IDs for this role
    let defaultAdminIds = [];
    if (isSuperAdmin) {
      defaultAdminIds = []; // ALL admins is default for Super Admin
    } else {
      defaultAdminIds = [adminID]; // Self is default for Team Leader & Regular Admin
    }
    
    // Check if current admin_ids are different from default
    const currentAdminIds = filter.admin_ids || [];
    
    // Sort both arrays for comparison
    const sortedCurrent = [...currentAdminIds].sort();
    const sortedDefault = [...defaultAdminIds].sort();
    
    // If arrays are different, user applied an admin filter
    if (sortedCurrent.length !== sortedDefault.length) {
      hasAdminFilter = true;
    } else {
      // Check each element
      for (let i = 0; i < sortedCurrent.length; i++) {
        if (sortedCurrent[i] !== sortedDefault[i]) {
          hasAdminFilter = true;
          break;
        }
      }
    }
  }

  // Return true ONLY if there's at least one REAL filter applied
  return !!(hasDateRange || hasPriority || hasTitle || hasOrderByPriority || hasAdminFilter);
};

  const handleFollowUp = (task) => {
    setSelectedTask(task);
    setFollowUpDateTime('');
    setFollowUpNotes('');
    setFollowUpErrors({ followUpDateTime: '' });
    setShowFollowUpModal(true);
  };

  const handleFollowUpSubmit = async () => {
    const newErrors = { followUpDateTime: '' };
    let hasError = false;

    if (!followUpDateTime) {
      newErrors.followUpDateTime = 'Please select a follow-up date';
      hasError = true;
    } else {
      const selectedDate = new Date(followUpDateTime);
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);

      if (selectedDate < currentDate) {
        newErrors.followUpDateTime = 'Follow-up date cannot be in the past';
        hasError = true;
      }
    }

    if (hasError) {
      setFollowUpErrors(newErrors);
      return;
    }

    setIsSubmitting(true);

    const payload = {
      id: selectedTask.id,
      description: followUpNotes || selectedTask.description,
      entity_type: 'INTERVIEW',
      title: selectedTask.title,
      admin_id: adminID,
      followup_date: followUpDateTime
    };

    try {
      await updateFollowUp(payload);
      setFollowupSuccess(true);
      setTimeout(() => setFollowupSuccess(false), 2000);
      await dispatch(fetchAllColumns());
      setShowFollowUpModal(false);
      setSelectedTask(null);
      setFollowUpDateTime('');
      setFollowUpNotes('');
      setFollowUpErrors({ followUpDateTime: '' });
    } catch (error) {
      console.error('Error updating follow-up:', error);
      alert('Failed to update follow-up');
    } finally {
      setIsSubmitting(false);
    }
  };

  const goToDetail = (task) => {
    if (task.candidateId) {
      navigate(`/candidate/${task.candidateId}`, {
        state: {
          mainTab: "NewFollowUp",
        },
      });
    } else {
      console.error('No candidateId found in task:', task);
    }
  };

  const handleOpenActionModal = (task) => {
    setSelectedTask(task);
    setSelectedOutcome('');
    setNotes('');
    setRescheduleDate('');
    setShowActionModal(true);
  };

  const handleActionSubmit = async () => {
    const newErrors = {
      outcome: '',
      reason: '',
      rescheduleDate: ''
    };

    if (!selectedOutcome) {
      newErrors.outcome = 'Please select an outcome';
      setErrors(newErrors);
      return;
    }

    if ((selectedOutcome === 'CALL_NOT_ATTENDED' ||
      selectedOutcome === 'OFFER_REJECTED' ||
      selectedOutcome === 'NOT_INTERESTED') && !selectedReason) {
      newErrors.reason = 'Please select a reason';
      setErrors(newErrors);
      return;
    }

    if (selectedOutcome === 'RESCHEDULE' && !rescheduleDate) {
      newErrors.rescheduleDate = 'Please select a reschedule date';
      setErrors(newErrors);
      return;
    }

    setErrors(newErrors);
    setIsSubmitting(true);

    const selectedReasonObj = reasonOptions.find(r => r.reason_name === selectedReason);

    let newStatus;
    if (selectedTask.status === 'TODO') {
      newStatus = 'COMPLETED';
    } else if (selectedTask.status === 'PENDING') {
      newStatus = 'COMPLETED';
    } else {
      newStatus = selectedTask.status;
    }

     const entityType = selectedTask.entity_type || 'INTERVIEW';

    const payload = {
      id: selectedTask.id,
      status: newStatus,
      outcome: selectedOutcome,
      description: notes || selectedTask.description,
      priority: selectedTask.priority,
      // entity_type: 'INTERVIEW',
         entity_type: entityType,
      entity_id: selectedTask.entity_id,
      title: selectedTask.title,
      admin_id: adminID,
      ...(selectedOutcome === 'RESCHEDULE' && { reschedule_date: rescheduleDate }),
      ...((selectedOutcome === 'CALL_NOT_ATTENDED' ||
        selectedOutcome === 'OFFER_REJECTED' ||
        selectedOutcome === 'NOT_INTERESTED') && {
        reason_id: selectedReasonObj?.id,
        reason_name: selectedReason
      })
    };

    try {
      await updateFollowUp(payload);
      setCompleteSuccess(true);
      setTimeout(() => setCompleteSuccess(false), 2000);
      await dispatch(fetchAllColumns());
      setShowActionModal(false);
      setSelectedTask(null);
      setSelectedOutcome('');
      setSelectedReason('');
      setNotes('');
      setRescheduleDate('');
      setShowReasonDropdown(false);
      setReasonOptions([]);
      setErrors({ outcome: '', reason: '', rescheduleDate: '' });
    } catch (error) {
      console.error('Error updating follow-up:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (activeMenuTask && !event.target.closest(`.${styles.actionMenu}`) && !event.target.closest(`.${styles.menuButton}`)) {
        setActiveMenuTask(null);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [activeMenuTask]);

  const getPriorityClass = (priority) => {
    switch (priority) {
      case 'critical': return styles.priorityCritical;
      case 'high': return styles.priorityHigh;
      case 'medium': return styles.priorityMedium;
      case 'low': return styles.priorityLow;
      default: return '';
    }
  };

  const getPriorityLabel = (priority) => {
    switch (priority) {
      case 'critical': return 'Critical';
      case 'high': return 'High';
      case 'medium': return 'Medium';
      case 'low': return 'Low';
      default: return priority;
    }
  };

  const getAvatarColor = (name) => {
    const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD'];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  const fetchReasons = async (outcome) => {
    let stageGroup = '';

    switch (outcome) {
      case 'CALL_NOT_ATTENDED':
        stageGroup = 'Call Not Attended';
        break;
      case 'OFFER_REJECTED':
        stageGroup = 'Offer Rejected';
        break;
      case 'NOT_INTERESTED':
        stageGroup = 'Not Interested';
        break;
      default:
        setShowReasonDropdown(false);
        return;
    }

    setLoadingReasons(true);
    setShowReasonDropdown(true);

    try {
      const response = await getReasons(stageGroup);
      const reasons = response.data || response;
      setReasonOptions(reasons);
      setSelectedReason('');
    } catch (error) {
      console.error('Error fetching reasons:', error);
      setReasonOptions([]);
    } finally {
      setLoadingReasons(false);
    }
  };

  const handleOutcomeChange = (e) => {
    const newOutcome = e.target.value;
    setSelectedOutcome(newOutcome);
    setSelectedReason('');

    if (newOutcome === 'CALL_NOT_ATTENDED' || newOutcome === 'OFFER_REJECTED' || newOutcome === 'NOT_INTERESTED') {
      fetchReasons(newOutcome);
    } else {
      setShowReasonDropdown(false);
      setReasonOptions([]);
    }
  };

  const handleEdit = (task) => {
    setSelectedTask(task);
    setShowUpdateModal(true);
  };

  const handleUpdateSuccess = (result) => {
    console.log('Follow-up updated successfully:', result);
    setShowUpdateModal(false);
    setSelectedTask(null);
    setUpdateSuccess(true);
    setTimeout(() => setUpdateSuccess(false), 2000);
    dispatch(fetchAllColumns());
  };

  const handleUpdateCancel = () => {
    setShowUpdateModal(false);
    setSelectedTask(null);
  };

  const refreshColumn = (columnKey, status) => {
    dispatch(fetchFollowUps({ columnKey, status, useColumnFilter: true }));
  };

const handlePageChange = (columnKey, newPage) => {
  const statusMap = { todo: 'TODO', pending: 'PENDING', completed: 'COMPLETED' };
  
  // ✅ Read filter BEFORE dispatching setColumnPage
  const currentFilter = columnFilters[columnKey];
  
  const hasActiveColumnFilter = 
    (currentFilter?.dateRange?.start && currentFilter?.dateRange?.end) ||
    currentFilter?.priority ||
    currentFilter?.orderByPriority ||
    (currentFilter?.admin_ids && currentFilter.admin_ids.length > 0) ||
    currentFilter?._adminFilterApplied === true;

  const globalFilterApplied = globalFilter?._adminFilterApplied === true;

  console.log(`📄 Page change [${columnKey}] to page ${newPage}`, {
    hasActiveColumnFilter,
    globalFilterApplied,
    currentFilter
  });

  // ✅ Update page in Redux
  dispatch(setColumnPage({ columnKey, page: newPage }));

  // ✅ Determine which filter to use
  const useColumnFilter = hasActiveColumnFilter && !globalFilterApplied;

  dispatch(fetchFollowUps({
    columnKey,
    status: statusMap[columnKey],
    useColumnFilter,
    page: newPage,
    force: true
  }));
};

  // const handleApplyGlobalFilter = (filterData) => {
  //   console.log('Applying global filter:', filterData);
    
  //   let finalFilterData = { ...filterData };
  //   if (!isSuperAdmin && (!finalFilterData.admin_ids || finalFilterData.admin_ids.length === 0)) {
  //     finalFilterData.admin_ids = [adminID];
  //   }
    
  //   dispatch(updateGlobalFilter(finalFilterData));
  //   dispatch(setShowFilterModal(null));
  //   dispatch(fetchAllColumns());
  // };

// Update handleApplyGlobalFilter in NewFollowUp.js
const handleApplyGlobalFilter = (filterData) => {
  console.log('Applying global filter:', filterData);
  
  // ✅ Check if admin filter is actually different from default
  const isSuperAdmin = adminDetails?.roleID == 1;
  const isTeamLeader = localStorage.getItem("teamLeader") == "true";
  
  let defaultAdminIds = [];
  if (isSuperAdmin) {
    defaultAdminIds = [];
  } else {
    defaultAdminIds = [adminID];
  }
  
  const currentAdminIds = filterData.admin_ids || [];
  const sortedCurrent = [...currentAdminIds].sort();
  const sortedDefault = [...defaultAdminIds].sort();
  
  let isAdminFilterDifferent = false;
  if (sortedCurrent.length !== sortedDefault.length) {
    isAdminFilterDifferent = true;
  } else {
    for (let i = 0; i < sortedCurrent.length; i++) {
      if (sortedCurrent[i] !== sortedDefault[i]) {
        isAdminFilterDifferent = true;
        break;
      }
    }
  }
  
  // ✅ Only set _adminFilterApplied to true if admin filter is different from default
  let finalFilterData = { ...filterData };
  if (isAdminFilterDifferent) {
    finalFilterData._adminFilterApplied = true;
  } else {
    finalFilterData._adminFilterApplied = false;
  }
  
  // Only apply default admin_ids if NO admin_ids were provided in the filter
  if (finalFilterData.admin_ids === undefined) {
    if (!isSuperAdmin && !isTeamLeader) {
      finalFilterData.admin_ids = [adminID];
    } else {
      finalFilterData.admin_ids = [];
    }
  }
  
  console.log('📤 Applying global filter with admin_ids:', finalFilterData.admin_ids, '_adminFilterApplied:', finalFilterData._adminFilterApplied);
  
  dispatch(updateGlobalFilter(finalFilterData));
  dispatch(setShowFilterModal(null));
  dispatch(fetchAllColumns());
};

//  const handleClearGlobalFilter = (clearedFilterData = null) => {
//   console.log('Clearing global filter with data:', clearedFilterData);
  
//   // Use the provided clearedFilterData or create default
//   const filterToApply = clearedFilterData || {
//     dateRange: { start: '', end: '' },
//     autoComplete: '',
//     priority: null,
//     orderByPriority: false,
//     // admin_ids: isSuperAdmin ? [] : [adminID],
// admin_ids: (isSuperAdmin || isTeamLeader) ? [] : [adminID],
//     title: null
//   };
  
//   // Ensure admin_ids is set correctly
//   if (!isSuperAdmin && (!filterToApply.admin_ids || filterToApply.admin_ids.length === 0)) {
//     filterToApply.admin_ids = [adminID];
//   }
  
//   dispatch(updateGlobalFilter(filterToApply));
//   dispatch(setShowFilterModal(null));
//   dispatch(fetchAllColumns());
// };

const handleClearGlobalFilter = (clearedFilterData = null) => {
  console.log('Clearing global filter with data:', clearedFilterData);
  
  const filterToApply = clearedFilterData || {
    dateRange: { start: '', end: '' },
    autoComplete: '',
    priority: null,
    orderByPriority: false,
    admin_ids: isSuperAdmin ? [] : [adminID],
    _adminFilterApplied: false,  // ✅ MUST be false
    title: null
  };
  
  // Ensure _adminFilterApplied is set to false
  filterToApply._adminFilterApplied = false;
  
  dispatch(updateGlobalFilter(filterToApply));
  dispatch(setShowFilterModal(null));
  dispatch(fetchAllColumns());
};
  // const handleApplyColumnFilter = (columnKey, filterData) => {
  //   console.log(`Applying column filter for ${columnKey}:`, filterData);
    
  //   let finalFilterData = { ...filterData };
  //   if (!isSuperAdmin && (!finalFilterData.admin_ids || finalFilterData.admin_ids.length === 0)) {
  //     finalFilterData.admin_ids = [adminID];
  //   }
    
  //   dispatch(updateColumnFilter({
  //     columnKey,
  //     filterData: finalFilterData
  //   }));
  //   dispatch(setShowFilterModal(null));

  //   const statusMap = { todo: 'TODO', pending: 'PENDING', completed: 'COMPLETED' };
  //   dispatch(fetchFollowUps({ columnKey, status: statusMap[columnKey], useColumnFilter: true }));
  // };

//   const handleClearColumnFilter = (columnKey, clearedFilterData = null) => {
//   console.log(`Clearing column filter for ${columnKey} with data:`, clearedFilterData);
  
//   // Use the provided clearedFilterData or create default
//   const filterToApply = clearedFilterData || {
//     dateRange: { start: '', end: '' },
//     autoComplete: '',
//     priority: null,
//     orderByPriority: false,
//     // admin_ids: isSuperAdmin ? [] : [adminID],
    
// admin_ids: (isSuperAdmin || isTeamLeader) ? [] : [adminID],
//     title: null,
//     page: 1
//   };
  
//   // Ensure admin_ids is set correctly
//   if (!isSuperAdmin && (!filterToApply.admin_ids || filterToApply.admin_ids.length === 0)) {
//     filterToApply.admin_ids = [adminID];
//   }
  
//   dispatch(updateColumnFilter({
//     columnKey,
//     filterData: filterToApply
//   }));
  
//   dispatch(setShowFilterModal(null));
  
//   const statusMap = { todo: 'TODO', pending: 'PENDING', completed: 'COMPLETED' };
//   dispatch(fetchFollowUps({ columnKey, status: statusMap[columnKey], useColumnFilter: true }));
// };


const handleApplyColumnFilter = (columnKey, filterData) => {
  console.log(`Applying column filter for ${columnKey}:`, filterData);
  
  // ✅ DON'T override admin_ids here - keep what came from the filter
  let finalFilterData = { ...filterData, _adminFilterApplied: true };
  
  // Only apply default admin_ids if NO admin_ids were provided in the filter
  // AND the user is not Super Admin or Team Leader
  if (finalFilterData.admin_ids === undefined) {
    if (!isSuperAdmin ) {
      finalFilterData.admin_ids = [adminID];
    } else {
      finalFilterData.admin_ids = [];
    }
  }
  
  dispatch(updateColumnFilter({
    columnKey,
    filterData: finalFilterData
  }));
  dispatch(setShowFilterModal(null));

  const statusMap = { todo: 'TODO', pending: 'PENDING', completed: 'COMPLETED' };
  dispatch(fetchFollowUps({ columnKey, status: statusMap[columnKey], useColumnFilter: true }));
};

const handleClearColumnFilter = (columnKey, clearedFilterData = null) => {
  console.log(`Clearing column filter for ${columnKey} with data:`, clearedFilterData);
  
  const filterToApply = clearedFilterData || {
    dateRange: { start: '', end: '' },
    autoComplete: '',
    priority: null,
    orderByPriority: false,
    admin_ids: isSuperAdmin ? [] : [adminID],
    title: null,
    _adminFilterApplied: false,  // ✅ MUST be false
    page: 1
  };
  
  // Ensure _adminFilterApplied is set to false
  filterToApply._adminFilterApplied = false;
  
  dispatch(updateColumnFilter({
    columnKey,
    filterData: filterToApply
  }));
  
  dispatch(setShowFilterModal(null));
  
  const statusMap = { todo: 'TODO', pending: 'PENDING', completed: 'COMPLETED' };
  dispatch(fetchFollowUps({ columnKey, status: statusMap[columnKey], useColumnFilter: true }));
};

const getGlobalFilterCount = () => {
  let count = 0;
  
  // Count date range - only if both exist
  if (globalFilter?.dateRange?.start && globalFilter?.dateRange?.end) {
    count++;
  }
  
  // Count priority - only if not null/empty
  if (globalFilter?.priority && globalFilter?.priority !== '' && globalFilter?.priority !== null) {
    count++;
  }
  
  // Count orderByPriority - only if true
  if (globalFilter?.orderByPriority === true) {
    count++;
  }
  
  // Count title - only if not null/empty
  if (globalFilter?.title && globalFilter.title !== '' && globalFilter.title !== null) {
    count++;
  }

  // ✅ Count admin filter - ONLY if it's different from default
  if (globalFilter?._adminFilterApplied === true) {
    const isSuperAdmin = adminDetails?.roleID == 1;
    const isTeamLeader = localStorage.getItem("teamLeader") == "true";
    
    let defaultAdminIds = [];
    if (isSuperAdmin) {
      defaultAdminIds = [];
    } else {
      defaultAdminIds = [adminID];
    }
    
    const currentAdminIds = globalFilter.admin_ids || [];
    const sortedCurrent = [...currentAdminIds].sort();
    const sortedDefault = [...defaultAdminIds].sort();
    
    let isDifferent = false;
    if (sortedCurrent.length !== sortedDefault.length) {
      isDifferent = true;
    } else {
      for (let i = 0; i < sortedCurrent.length; i++) {
        if (sortedCurrent[i] !== sortedDefault[i]) {
          isDifferent = true;
          break;
        }
      }
    }
    
    if (isDifferent) {
      count++;
    }
  }

  return count;
};
  const globalFilterCount = getGlobalFilterCount();
  const hasGlobalRealFiltersFlag = hasRealFilters(globalFilter);

  const UserAvatar = ({ name }) => {
    return (
      <div className={styles.userAvatarContainer} title={name}>
        <div className={styles.userAvatar}
        //  style={{ backgroundColor: getAvatarColor(name) }}>
         style={{ backgroundColor: "#169c50" }}>
          {getInitials(name)}
        </div>
      </div>
    );
  };

  // const TaskCard = ({ task }) => {
  //   const isMenuOpen = activeMenuTask === task.id;


  //   return (
  //     <div className={styles.followupCard}>
  //       <div className={styles.cardHeader}>
  //         <span className={`${styles.priorityBadge} ${getPriorityClass(task.priority)}`}>
  //           {getPriorityLabel(task.priority)}
  //         </span>
  //         <div className={styles.cardHeaderRight}>
  //           <span className={styles.cardDate}>{task.displayDate}</span>
  //           <button
  //             className={styles.menuButton}
  //             onClick={(e) => {
  //               e.stopPropagation();
  //               setActiveMenuTask(isMenuOpen ? null : task.id);
  //             }}
  //           >
  //             <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
  //               <circle cx="12" cy="6" r="1.5" fill="currentColor" />
  //               <circle cx="12" cy="12" r="1.5" fill="currentColor" />
  //               <circle cx="12" cy="18" r="1.5" fill="currentColor" />
  //             </svg>
  //           </button>
  //           {isMenuOpen && (
  //             <ActionMenu
  //               task={task}
  //               onClose={() => setActiveMenuTask(null)}
  //               onComplete={handleOpenActionModal}
  //               // onEdit={handleOpenActionModal}
  //               onEdit={handleEdit}
  //               onFollowUp={handleFollowUp}
  //             />
  //           )}
  //         </div>
  //       </div>

  //       {task.candidateName && (
  //         <div className={styles.cardCandidate}>
  //           <span
  //             className={styles.candidateName}
  //             // onClick={() => handleCandidateDetails(task.candidateId, "RegisterCandidate")}
  //             onClick={() => goToDetail(task)}
  //           >
  //             {task.candidateName}
  //           </span>
  //         </div>
  //       )}

  //       <h4 className={styles.cardTitle}>{task.title}</h4>
  //       <p className={styles.cardDescription}>{task.description}</p>

  //       {task.user && (
  //         <div className={styles.cardUser}>
  //           <UserAvatar name={task.user} />
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  // const TaskCard = ({ task, columnKey }) => {
  //   const isMenuOpen = activeMenuTask === task.id;

  //   // ADD THIS LINE - to determine if menu should be shown
  //   const showMenu = columnKey === 'todo' || columnKey === 'pending';

  //   return (
  //     <div className={styles.followupCard}>
  //       <div className={styles.cardHeader}>
  //         <span className={`${styles.priorityBadge} ${getPriorityClass(task.priority)}`}>
  //           {getPriorityLabel(task.priority)}
  //         </span>
  //         <div className={styles.cardHeaderRight}>
  //           <span className={styles.cardDate}>{task.displayDate}</span>
  //           {/* CHANGE THIS LINE - add showMenu condition */}
  //           {showMenu && (
  //             <button
  //               className={styles.menuButton}
  //               onClick={(e) => {
  //                 e.stopPropagation();
  //                 setActiveMenuTask(isMenuOpen ? null : task.id);
  //               }}
  //             >
  //               <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
  //                 <circle cx="12" cy="6" r="1.5" fill="currentColor" />
  //                 <circle cx="12" cy="12" r="1.5" fill="currentColor" />
  //                 <circle cx="12" cy="18" r="1.5" fill="currentColor" />
  //               </svg>
  //             </button>
  //           )}
  //           {/* CHANGE THIS LINE - add showMenu condition */}
  //           {isMenuOpen && showMenu && (
  //             <ActionMenu
  //               task={task}
  //               onClose={() => setActiveMenuTask(null)}
  //               onComplete={handleOpenActionModal}
  //               onEdit={handleEdit}
  //               onFollowUp={handleFollowUp}
  //             />
  //           )}
  //         </div>
  //       </div>

  //       {task.candidateName && (
  //         <div className={styles.cardCandidate}>
  //           <span
  //             className={styles.candidateName}
  //             onClick={() => goToDetail(task)}
  //           >
  //             {task.candidateName}
  //           </span>
  //         </div>
  //       )}

  //       <h4 className={styles.cardTitle}>{task.title}</h4>
  //       <p className={styles.cardDescription}>{task.description}</p>

  //       {task.user && (
  //         <div className={styles.cardUser}>
  //           <UserAvatar name={task.user} />
  //         </div>
  //       )}
  //     </div>
  //   );
  // };
  const TaskCard = ({ task, columnKey , onSelectCandidate}) => {
  const showMenu = columnKey === 'todo' || columnKey === 'pending';

    const getMenuOptions = (task) => {
      const options = [
        {
          label: 'Complete',
          action: () => handleOpenActionModal(task)
        },
        {
          label: 'Edit',
          action: () => handleEdit(task)
        }
      ];

      const hideFollowUp = task.title === 'Joining Follow Up' || task.title === 'Interview Follow Up';
      // if (!hideFollowUp) {
      //   options.push({
      //     label: 'Follow-up',
      //     action: () => handleFollowUp(task)
      //   });
      // }

      return options;
    };

    const cleanedDescription = timeRemove(task.description);
const handleClick = () => {
  if (typeof onSelectCandidate === "function") {
    onSelectCandidate(task);
  } else {
    console.error("❌ onSelectCandidate missing at CandidateCard");
  }
};
return (
  <div className={styles.followupCard}>
    {/* Header with title+priority on left, date+menu on right */}
    <div className={styles.cardHeader}>
      <div className={styles.cardHeaderLeft}>
        <h4 className={styles.cardTitle}>{task.title}</h4>
        <span className={`${styles.priorityBadge} ${getPriorityClass(task.priority)}`}>
          {getPriorityLabel(task.priority)}
        </span>
      </div>
      <div className={styles.cardHeaderRight}>
        <span className={styles.cardDate}>{task.displayDate}</span>
        {showMenu && <ActionMenu options={getMenuOptions(task)} />}
      </div>
    </div>

    {/* Candidate name below */}
    {task.candidateName && (
      <div className={styles.cardCandidate}>
        <span
          className={styles.candidateName}
           onClick={handleClick}
        >
          {task.candidateName}
        </span>
      </div>
    )}
    
    {/* Description */}
    <p className={styles.cardDescription}>{cleanedDescription}</p>

        {task.user && (
          <div className={styles.cardUser}>
            <UserAvatar name={task.user} />
          </div>
        )}
      </div>
    );
  };

 const Pagination = ({ currentPage, totalPages, onPageChange, columnKey }) => {
  const getPageNumbers = () => {
    // For very small number of pages (<= 3), show all
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    
    // For 4 pages specifically
    if (totalPages === 4) {
      if (currentPage === 1) {
        return [1, 2, '...', 4];
      } else if (currentPage === 2) {
        return [1, 2, 3, 4];
      } else if (currentPage === 3) {
        return [1, 2, 3, 4];
      } else if (currentPage === 4) {
        return [1, '...', 3, 4];
      }
    }
    
    // For more than 4 pages
    if (currentPage <= 2) {
      // At beginning: 1 2 3 ... totalPages
      return [1, 2, 3, '...', totalPages];
    } else if (currentPage >= totalPages - 1) {
      // At end: 1 ... totalPages-2 totalPages-1 totalPages
      return [1, '...', totalPages - 2, totalPages - 1, totalPages];
    } else {
      // In middle: 1 ... currentPage ... totalPages
      return [1, '...', currentPage, '...', totalPages];
    }
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className={styles.paginationContainer}>
      <div className={styles.paginationControls}>
        <button
          className={styles.paginationButton}
          onClick={() => onPageChange(columnKey, currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        {pageNumbers.map((pageNum, index) => (
          pageNum === '...' ? (
            <span key={`ellipsis-${index}`} className={styles.paginationEllipsis}>
              ...
            </span>
          ) : (
            <button
              key={pageNum}
              className={`${styles.paginationButton} ${currentPage === pageNum ? styles.activePage : ''}`}
              onClick={() => onPageChange(columnKey, pageNum)}
            >
              {pageNum}
            </button>
          )
        ))}

        <button
          className={styles.paginationButton}
          onClick={() => onPageChange(columnKey, currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

  const Column = ({ title, columnKey, status }) => {
    const tasks = columns[columnKey]?.items || [];
    const total = columns[columnKey]?.total || 0;
    const columnFilter = columnFilters[columnKey] || {};
    const isLoading = loadingStates[columnKey] || false;
    const currentPage = columnFilter?.page || 1;
    const limit = columnFilter?.limit || 10;
    const totalPages = Math.max(1, Math.ceil(total / limit));

    const hasColumnRealFiltersFlag = hasRealFilters(columnFilter);
    const showRedDot = hasColumnRealFiltersFlag || hasGlobalRealFiltersFlag;

    const filteredTasks = tasks;

      const getColumnClass = () => {
    switch(columnKey) {
      case 'pending':
        return styles.columnPending;
      case 'completed':
        return styles.columnCompleted;
         case 'todo':
        return styles.columnToDo;
      default:
        return '';
    }
  };

    return (
        <div className={`${styles.followupColumn} ${getColumnClass()}`}>
        <div className={styles.columnHeader}>
          <div className={styles.columnHeaderLeft}>
            <h2>{title}</h2>
            <span className={styles.taskCount}>{total}</span>
          </div>
          <div className={styles.columnHeaderRight}>
            <button
              className={`${styles.refreshIcon} ${isLoading ? styles.refreshing : ''}`}
              onClick={() => refreshColumn(columnKey, status)}
              disabled={isLoading}
            >
               <TfiReload/>
            </button>

            <button
              className={`${styles.filterButton} ${showRedDot ? styles.activeFilter : ''}`}
              onClick={() => dispatch(setShowFilterModal(columnKey))}
            >
               <MdTune />
              Filter
              {showRedDot && <span className={styles.filterDot}></span>}
            </button>
          </div>
        </div>

        <div className={styles.taskListWrapper}>
          <div className={styles.taskList}>
            {isLoading && tasks.length === 0 ? (
              <div className={styles.loadingTasks}>Loading...</div>
            ) : (
              // filteredTasks.map(task => <TaskCard key={task.id} task={task} />)
              filteredTasks.map(task => <TaskCard key={task.id} task={task} columnKey={columnKey} onSelectCandidate={onSelectCandidate} />)
            )}
            {!isLoading && filteredTasks.length === 0 && (
              <div className={styles.noTasks}>
                {showRedDot ? 'No tasks match your filters' : 'No tasks found'}
              </div>
            )}
          </div>
        </div>

        {total > 0 && (
          <div className={styles.paginationContainer}>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              columnKey={columnKey}
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <>
     <div className={styles.filterBar}>
  <div className={styles.filterBarLeft}>
    {globalFilterCount > 0 && (
      <span className={styles.activeFilterBadge}>
        Common: {globalFilterCount} active filter{globalFilterCount > 1 ? 's' : ''}
      </span>
    )}
    {error && <span className={styles.errorMessage}>{error}</span>}
  </div>
  <div className={styles.filterBarRight}>
    <button
      className={`${styles.filterButton} ${hasGlobalRealFiltersFlag ? styles.activeFilter : ''}`}
      onClick={() => dispatch(setShowFilterModal('global'))}
    >
      <MdTune />
      Filter
      {hasGlobalRealFiltersFlag && globalFilterCount > 0 && (
        <span className={styles.filterCount}>{globalFilterCount}</span>
      )}
    </button>
  </div>
</div>
      <div className={styles.followupContainer}>
        <Column title="To-Do" columnKey="todo" status="TODO" />
        <Column title="Pending" columnKey="pending" status="PENDING" />
        <Column title="Completed" columnKey="completed" status="COMPLETED" />
      </div>

      {showFilterModal && (
        <MyModal>
          <ModalContainer
            zIndex={1005}
            childComponent={
              <NewFilterFollowUp
                columnKey={showFilterModal === 'global' ? 'All Pipelines' : showFilterModal}
                isGlobal={showFilterModal === 'global'}
                currentFilter={showFilterModal === 'global' ? globalFilter : columnFilters[showFilterModal]}
                onApply={(filterData) => {
                  if (showFilterModal === 'global') {
                    handleApplyGlobalFilter(filterData);
                  } else {
                    handleApplyColumnFilter(showFilterModal, filterData);
                  }
                }}
                onClear={(clearedData) => {
                  if (showFilterModal === 'global') {
                    handleClearGlobalFilter(clearedData);
                  } else {
                    handleClearColumnFilter(showFilterModal, clearedData);
                  }
                }}
                onClose={() => dispatch(setShowFilterModal(null))}
              />
            }
          />
        </MyModal>
      )}

      {showUpdateModal && selectedTask && (
        <MyModal>
          <ModalContainer
            zIndex={2000}
            childComponent={
              <UpdateFollowUp
                followUpId={selectedTask.id}
                onSuccess={handleUpdateSuccess}
                onCancel={handleUpdateCancel}
              />
            }
          />
        </MyModal>
      )}

      {showFollowUpModal && selectedTask && (
        <MyModal>
          <ModalContainer
            zIndex={2000}
            childComponent={
              <div className={styles.actionModalContainer}>
                <div className={styles.actionModalHeader}>
                  <h3>Follow-up Reschedule</h3>
                  <button
                    className={styles.closeModalButton}
                    onClick={() => {
                      setShowFollowUpModal(false);
                      setSelectedTask(null);
                      setFollowUpDateTime('');
                      setFollowUpNotes('');
                      setFollowUpErrors({ followUpDateTime: '' });
                    }}
                  >
                    ×
                  </button>
                </div>

                <div className={styles.actionModalContent}>
                  <div className={styles.formGroup}>
                    <label>Follow-up Date *</label>
                    <input
                      type="date"
                      value={followUpDateTime}
                      onChange={(e) => {
                        setFollowUpDateTime(e.target.value);
                        if (followUpErrors.followUpDateTime) {
                          setFollowUpErrors({ followUpDateTime: '' });
                        }
                      }}
                      className={`${styles.input} ${followUpErrors.followUpDateTime ? styles.errorInput : ''}`}
                      min={new Date().toISOString().split('T')[0]}
                    />
                    {followUpErrors.followUpDateTime && (
                      <span className={styles.errorMessage}>{followUpErrors.followUpDateTime}</span>
                    )}
                  </div>

                  <div className={styles.formGroup}>
                    <label>Notes</label>
                    <textarea
                      value={followUpNotes}
                      onChange={(e) => setFollowUpNotes(e.target.value)}
                      placeholder="Add notes..."
                      className={styles.textarea}
                      rows="4"
                    />
                  </div>
                </div>

                <div className={styles.actionModalFooter}>
                  <button
                    className={styles.cancelButton}
                    onClick={() => {
                      setShowFollowUpModal(false);
                      setSelectedTask(null);
                      setFollowUpDateTime('');
                      setFollowUpNotes('');
                      setFollowUpErrors({ followUpDateTime: '' });
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className={styles.submitButton}
                    onClick={handleFollowUpSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Scheduling...' : 'Schedule Follow-up'}
                  </button>
                </div>
              </div>
            }
          />
        </MyModal>
      )}

      {updateSuccess && (
        <MyModal>
          <ModalContainer
            childComponent={
              <SuccessTick HeadText="Follow-up Updated Successfully!" />
            }
          />
        </MyModal>
      )}

      {completeSuccess && (
        <MyModal>
          <ModalContainer
            childComponent={
              <SuccessTick HeadText="Status Updated Successfully!" />
            }
          />
        </MyModal>
      )}

      {followupSuccess && (
        <MyModal>
          <ModalContainer
            childComponent={
              <SuccessTick HeadText="Follow-up Date Updated Successfully!" />
            }
          />
        </MyModal>
      )}

      {showActionModal && selectedTask && (
        <MyModal>
          <ModalContainer
            zIndex={2000}
            childComponent={
              <div className={styles.actionModalContainer}>
                <div className={styles.actionModalHeader}>
                  <h5>Status Update</h5>
                  <button
                    className={styles.closeModalButton}
                    onClick={() => {
                      setShowActionModal(false);
                      setSelectedTask(null);
                      setSelectedOutcome('');
                      setSelectedReason('');
                      setNotes('');
                      setRescheduleDate('');
                      setShowReasonDropdown(false);
                      setErrors({ outcome: '', reason: '', rescheduleDate: '' });
                    }}
                  >
                    <AiOutlineClose />
                  </button>
                </div>

                <div className={styles.actionModalContent}>
                  <div className={styles.formGroup}>
                    <label>What happened Now? *</label>
                    <select
                      value={selectedOutcome}
                      onChange={(e) => {
                        handleOutcomeChange(e);
                        setErrors({ ...errors, outcome: '' });
                      }}
                      className={`${styles.select} ${errors.outcome ? styles.errorInput : ''}`}
                    >
                      <option value="">Select option</option>
                      {getOutcomeOptions(selectedTask?.title).map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    {errors.outcome && <span className={styles.errorMessage}>{errors.outcome}</span>}
                  </div>

                  {showReasonDropdown && (
                    <div className={styles.formGroup}>
                      <label>Reason *</label>
                      {loadingReasons ? (
                        <div className={styles.loadingReasons}>Loading reasons...</div>
                      ) : (
                        <>
                          <select
                            value={selectedReason}
                            onChange={(e) => {
                              setSelectedReason(e.target.value);
                              setErrors({ ...errors, reason: '' });
                            }}
                            className={`${styles.select} ${errors.reason ? styles.errorInput : ''}`}
                          >
                            <option value="">Select reason</option>
                            {reasonOptions.map((reason) => (
                              <option key={reason.id} value={reason.reason_name}>
                                {reason.reason_name}
                              </option>
                            ))}
                          </select>
                          {errors.reason && <span className={styles.errorMessage}>{errors.reason}</span>}
                        </>
                      )}
                    </div>
                  )}

                  {selectedOutcome === 'RESCHEDULE' && (
                    <div className={styles.formGroup}>
                      <label>
                        {(selectedTask.title?.toLowerCase().includes('joining') &&
                          selectedTask.title?.toLowerCase().includes('follow'))
                          ? 'Joining Follow Up Reschedule *'
                          : 'Interview Follow Up Reschedule *'}
                      </label>
                      <input
                        type="date"
                        value={rescheduleDate}
                        onChange={(e) => {
                          setRescheduleDate(e.target.value);
                          setErrors({ ...errors, rescheduleDate: '' });
                        }}
                        className={`${styles.input} ${errors.rescheduleDate ? styles.errorInput : ''}`}
                        min={new Date().toISOString().split('T')[0]}
                      />
                      {errors.rescheduleDate && <span className={styles.errorMessage}>{errors.rescheduleDate}</span>}
                    </div>
                  )}

                  <div className={styles.formGroup}>
                    <label>Notes</label>
                    <textarea
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                      placeholder="Add notes..."
                      className={styles.textarea}
                      rows="4"
                    />
                  </div>
                </div>

                <div className={styles.actionModalFooter}>
                  <button
                    className={styles.cancelButton}
                    onClick={() => {
                      setShowActionModal(false);
                      setSelectedTask(null);
                      setSelectedOutcome('');
                      setSelectedReason('');
                      setNotes('');
                      setRescheduleDate('');
                      setShowReasonDropdown(false);
                      setErrors({ outcome: '', reason: '', rescheduleDate: '' });
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className={styles.submitButton}
                    onClick={handleActionSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Updating...' : 'Update'}
                  </button>
                </div>
              </div>
            }
          />
        </MyModal>
      )}
    </>
  );
};

export default NewFollowUp;